export default {"src":"/_next/static/image/public/images/ic_homecare_outline.9e417d5b1515e7fe35045bc274397b39.svg","height":40,"width":40};